const CartTypes = {
  ADD_ITEM: 'ADD_ITEM',
  DECREASE_ITEM_UNIT: 'DECREASE_ITEM_UNIT',
  ADD_ITEM_UNIT: 'ADD_ITEM_UNIT',
  DELETE_ITEM: 'DELETE_ITEM',
  HIDE_CART: 'HIDE_CART',
  SHOW_CART: 'SHOW_CART',
  CLEAR_CART: 'CLEAR_CART',
};

export default CartTypes;
